export function createNavigation(id, { links, context }) {
    return {
        id: Symbol(id),
        links,
        context,
    };
}
